jQuery(document).ready(function ($) {
  $("#cmn-toggle-4").on("change", () => {
    var url = location.pathname
    if ($("#cmn-toggle-4").is(":checked")) {
      location.href = `${url}?displayed=all`;
    } else {
      location.href = url;
    }
  });
  $(".js-favorite-hide-btn").on("click", (e) => {
    alert(I18n.t('js.favorite.alert_hidden'));
    e.preventDefault();
  });
});
